import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "_api"; // Adjust the import path to your API configuration

// Thunk สำหรับ fetch ข้อมูล
export const fetchOverdueDataPawn = createAsyncThunk(
  "overduePawn/fetchData", // เปลี่ยนชื่อ action เป็น overduePawn/fetchData
  async (_, { rejectWithValue }) => {
    try {
      const { data, isStatus } = await api.pawn.getOrder();
      if (isStatus) {
        // Filter the data where order_status is 10
        const filteredData = data?.filter((item) => item.order_status === 10);
        return filteredData; // Return the filtered data
      }
      return rejectWithValue("Error fetching data");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const overduePawn = createSlice({
  name: "overduePawn",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOverdueDataPawn.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOverdueDataPawn.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchOverdueDataPawn.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default overduePawn.reducer;
